// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import {} from "../types";

// ---------------------------------------------------------------
// Mutation Keys
// ---------------------------------------------------------------
export const deleteAttachmentMutationKey = ["deleteAttachment"] as const;
export const postAttachmentsMutationKey = ["postAttachments"] as const;
export const postQuestionAttachmentsMutationKey = [
  "postQuestionAttachments",
] as const;

// ---------------------------------------------------------------
// Query Keys
// ---------------------------------------------------------------
